import aes from './aes'
class storage {
   
   save(key,value) {
      localStorage.setItem(this.name+'.'+key,aes.encode(JSON.stringify(value)))
   }
   load(key) {
      return (localStorage.getItem(this.name+'.'+key) === null) ?  null : JSON.parse(aes.decode(localStorage.getItem(this.name+'.'+key)))
   }
   exist(key){
      return (localStorage.getItem(this.name+'.'+key) === null) ? false : true
   }
   remove(key){
      console.log(this.name+'.'+key)
      localStorage.removeItem(this.name+'.'+key)
   }
}
export default storage
